"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Index_1 = require("./pages/Index");
var MainStore_1 = require("./store/MainStore");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var currency_1 = require("utils/currency");
var MegatronFrontForPC = (function (_super) {
    __extends(MegatronFrontForPC, _super);
    function MegatronFrontForPC(props) {
        var _this = _super.call(this, props) || this;
        var _a = _this.props, _b = _a.country, country = _b === void 0 ? "USA" : _b, _c = _a.lang, lang = _c === void 0 ? "en" : _c, _d = _a.currency, currency = _d === void 0 ? "USD" : _d;
        isomorphismConstant_1.default.country = country;
        isomorphismConstant_1.default.language = lang;
        isomorphismConstant_1.default.currency = currency;
        isomorphismConstant_1.default.priceGraph = currency_1.priceGraph(currency);
        _this.store = new MainStore_1.default();
        return _this;
    }
    MegatronFrontForPC.prototype.render = function () {
        return React.createElement(Index_1.default, { store: this.store, stickToTop: this.props.stickToTop });
    };
    return MegatronFrontForPC;
}(React.Component));
exports.default = MegatronFrontForPC;
